import { render, staticRenderFns } from "./AddBtn.vue?vue&type=template&id=4f83c026&"
import script from "./AddBtn.vue?vue&type=script&lang=js&"
export * from "./AddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports